import React from 'react'
import { useMedia } from 'sb-hooks'

import Box from 'components/_new/layout/Box/Box'

import Row from './Row/Row'
import TotalPrice from './TotalPrice/TotalPrice'


const OrderInfo = ({ items, total, isFetching }) => {
  const { isMobile } = useMedia()

  return (
    <Box mt={!isMobile && '24'}>
      {
        items.map((item, index) => (
          <Row key={index} isFetching={isFetching} {...item} />
        ))
      }
      <Row id="total">
        <TotalPrice value={total} />
      </Row>
    </Box>
  )
}


export default OrderInfo
